
		<info-modal [title]="title" (onOk)="ok()">
			<loading [isLoad]="isLoad"></loading>
			
			<table class="table table-bordered">
				<thead>
					<tr class="info">
						<th>
							#
						</th>
						
						<th>
							{{ 'common.User' | translate }}
						</th>
						
						<th>
							{{ 'common.Site' | translate }}
						</th>
						
						<th>
							{{ 'common.Domain' | translate }}
						</th>
						
						<th>
							{{ 'adminstat.billing.expired_domains.domain ns' | translate }}
						</th>
						
						<th>
							{{ 'adminstat.billing.expired_domains.history' | translate }}
						</th>
						
						<th>
							{{ 'adminstat.billing.expired_domains.date ' + tableType | translate }}
						</th>
					</tr>
				</thead>
				
				<tbody>
					<tr *ngFor="let stat of stats; let i = index">
						<td>
							{{ i + 1 }}
						</td>
						
						<td>
							<gotosupport [value]="stat.email"></gotosupport>
						</td>
						
						<td>
							<site_info [siteUrl]="stat.url"></site_info>
						</td>
						
						<td>
							<a [attr.href]="'http://' + stat.domainName" target="_blank" rel="noreferrer">{{ stat.domainName }}</a>
						</td>
						
						<td>
							<ul *ngIf="stat.ns.length > 0">
								<li *ngFor="let _ns of stat.ns">
									{{ _ns }}
								</li>
							</ul>
						</td>
						
						<td>
							<ul *ngIf="stat.history.length > 0">
								<li *ngFor="let _ns of stat.history">
									{{ _ns.time }} - <b>{{ _ns.ns }}</b>
								</li>
							</ul>
						</td>
						
						<td>
							{{ stat.history[stat.history.length - 1].time }}
						</td>
					</tr>
				</tbody>
			</table>
		</info-modal>
	